// to generate new unique id 
export const generateRandomID = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

// to convert the date eg 11-sep-2024 to 11-09-2024
const monthMap = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12"
};
export const convertDate = (dateStr) => {
  const [day, month, year] = dateStr.split('-');
  const monthNumber = monthMap[month];
  return `${day}-${monthNumber}-${year}`;
};

export const convertFormatMonth = (date) => {   // assuming date coming is in dd-mm-yyyy format 
  const [day, month, year] = date.split('-')
  return `${month} ${day} ${year}`
}
export const convertFormatDay = (date) => {   // assuming date coming is in mm-dd-yyyy format 
  const [month, day, year] = date.split('-')
  return `${day} ${month} ${year}`
}
export const convertFormYearToDay = (date) => {  // assuming date is in yyyy-mm-dd format
  const [year, month, day] = date.split('-')
  return `${day}-${month}-${year}`
}



